var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiportalDeactivate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 26,
    height: 26,
    rx: 4,
    fill: "#FF5F5F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8892_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9497 8.05022C15.2161 5.31659 10.7838 5.31659 8.05022 8.05022C5.31659 10.7838 5.31659 15.216 8.05022 17.9497C10.7838 20.6833 15.216 20.6833 17.9497 17.9497C20.6834 15.216 20.6834 10.7838 17.9497 8.05022ZM13 18.251C11.5974 18.251 10.2787 17.7049 9.28688 16.713C8.29503 15.7213 7.7489 14.4026 7.7489 13C7.7489 11.9437 8.05876 10.9352 8.63522 10.0779L15.922 17.3647C15.0647 17.9412 14.0562 18.251 13 18.251ZM17.3638 15.9211L10.0779 8.63522C10.9352 8.05866 11.9438 7.7488 13 7.7488C14.4026 7.7488 15.7213 8.29503 16.7132 9.28688C18.5137 11.0875 18.7304 13.881 17.3638 15.9211Z",
    fill: "#CD0808"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8892_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiportalDeactivate);
export default __webpack_public_path__ + "static/media/BiportalDeactivate.85f33ce1314dd4f54328fd6f64b51c3c.svg";
export { ForwardRef as ReactComponent };